var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "500px",
        "click:outside": "cancel()",
        persistent:
          _vm.dialogModel.isModal == null ? false : _vm.dialogModel.isModal
      },
      model: {
        value: _vm.dialogModel.visible,
        callback: function($$v) {
          _vm.$set(_vm.dialogModel, "visible", $$v)
        },
        expression: "dialogModel.visible"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm.dialogModel.isInfoDialog
                ? _c(
                    "v-icon",
                    {
                      staticStyle: { color: "#34d9b9", "margin-left": "10px" }
                    },
                    [_vm._v("mdi-information")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.dialogModel.headline))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: _vm.dialogModel.formRef,
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.dialogModel.valid,
                    callback: function($$v) {
                      _vm.$set(_vm.dialogModel, "valid", $$v)
                    },
                    expression: "dialogModel.valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "py-0": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _vm.dialogModel.message
                            ? _c(
                                "v-flex",
                                { staticClass: "groupContainer" },
                                [
                                  !_vm.dialogModel.useTextArea
                                    ? _c("div", {
                                        staticClass: "text-message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.dialogModel.message
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.dialogModel.useTextArea
                                    ? _c("v-textarea", {
                                        staticClass: "textarea-message",
                                        attrs: {
                                          "auto-grow": "",
                                          "no-resize": "",
                                          readonly: "",
                                          flat: "",
                                          solo: ""
                                        },
                                        model: {
                                          value: _vm.dialogModel.message,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dialogModel,
                                              "message",
                                              $$v
                                            )
                                          },
                                          expression: "dialogModel.message"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.dialogModel.values, function(value) {
                            return _c(
                              "v-flex",
                              { key: value.id, attrs: { xs12: "" } },
                              [
                                value.display && value.type === "text"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "text",
                                            label: value.label,
                                            rules: value.rules
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "textarea"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: value.label,
                                            rules: value.rules,
                                            disabled: value.disable,
                                            "auto-grow": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.fixString(value)
                                            }
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "img"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-img", {
                                          attrs: {
                                            src: value.value,
                                            label: value.label,
                                            rules: value.rules
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "video"
                                  ? _c("v-flex", { attrs: { xs12: "" } }, [
                                      _c(
                                        "video",
                                        {
                                          attrs: {
                                            width: "420",
                                            height: "300",
                                            controls: ""
                                          }
                                        },
                                        [
                                          _c("source", {
                                            attrs: { src: value.value }
                                          })
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "number"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "number",
                                            label: value.label,
                                            rules: value.rules
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                value,
                                                "value",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "enum"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: value.enumItems,
                                            "item-text": "value",
                                            "item-value": "key",
                                            label: value.label,
                                            rules: value.rules,
                                            "error-messages":
                                              value.errorMessages
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeSelection(value)
                                            }
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "users"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c(
                                          "v-container",
                                          { attrs: { "px-0": "", "py-0": "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs9: "" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        items:
                                                          _vm.dialogModel
                                                            .metaInformation
                                                            .userSearchItems,
                                                        "search-input":
                                                          _vm.dialogModel
                                                            .metaInformation
                                                            .userSearchString,
                                                        "item-text": "email",
                                                        label:
                                                          "Search user by email adress",
                                                        placeholder:
                                                          "Type to search",
                                                        "hide-no-data": "",
                                                        "return-object": "",
                                                        rules: value.rules,
                                                        clearable: ""
                                                      },
                                                      on: {
                                                        "update:searchInput": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.dialogModel
                                                              .metaInformation,
                                                            "userSearchString",
                                                            $event
                                                          )
                                                        },
                                                        "update:search-input": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.dialogModel
                                                              .metaInformation,
                                                            "userSearchString",
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dialogModel
                                                            .metaInformation
                                                            .selectedUser,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dialogModel
                                                              .metaInformation,
                                                            "selectedUser",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dialogModel.metaInformation.selectedUser"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs2: "" } },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "success",
                                                          disabled: !_vm
                                                            .dialogModel
                                                            .metaInformation
                                                            .selectedUser
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.dialogModel.metaInformation.addUser(
                                                              _vm.dialogModel
                                                                .metaInformation
                                                                .selectedUser
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Add\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "userList",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass: "mx-auto",
                                                        attrs: { tile: "" }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          {
                                                            attrs: { dense: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-subheader",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    value.label
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.dialogModel
                                                                .metaInformation
                                                                .userList,
                                                              function(
                                                                item,
                                                                i
                                                              ) {
                                                                return _vm
                                                                  .dialogModel
                                                                  .metaInformation
                                                                  .userList &&
                                                                  _vm
                                                                    .dialogModel
                                                                    .metaInformation
                                                                    .userList
                                                                    .length > 0
                                                                  ? _c(
                                                                      "v-list-item",
                                                                      {
                                                                        key: i
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-content",
                                                                          [
                                                                            _c(
                                                                              "v-flex",
                                                                              [
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      "d-inline-block":
                                                                                        "",
                                                                                      "pr-0":
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.firstName
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      "d-inline-block":
                                                                                        "",
                                                                                      "pl-0":
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.lastName
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      "d-inline-block":
                                                                                        "",
                                                                                      "mx-3":
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.email
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-action",
                                                                          [
                                                                            _c(
                                                                              "v-tooltip",
                                                                              {
                                                                                attrs: {
                                                                                  right:
                                                                                    ""
                                                                                },
                                                                                scopedSlots: _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key:
                                                                                        "activator",
                                                                                      fn: function(
                                                                                        ref
                                                                                      ) {
                                                                                        var on =
                                                                                          ref.on
                                                                                        return [
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            _vm._g(
                                                                                              {
                                                                                                attrs: {
                                                                                                  icon:
                                                                                                    ""
                                                                                                },
                                                                                                on: {
                                                                                                  click: function(
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.dialogModel.metaInformation.removeUserFromList(
                                                                                                      item.id
                                                                                                    )
                                                                                                  }
                                                                                                }
                                                                                              },
                                                                                              on
                                                                                            ),
                                                                                            [
                                                                                              _c(
                                                                                                "v-icon",
                                                                                                {
                                                                                                  attrs: {
                                                                                                    color:
                                                                                                      "red"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "mdi-account-remove-outline"
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      }
                                                                                    }
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                )
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                Remove user\n                              "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.dialogModel
                                                              .metaInformation
                                                              .userList
                                                              .length === 0
                                                              ? _c(
                                                                  "v-list-item",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _c(
                                                                          "v-flex",
                                                                          {
                                                                            attrs: {
                                                                              "d-inline-block":
                                                                                "",
                                                                              "ml-3":
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "No users"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "autocomplete"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: value.enumItems,
                                            "item-text": "value",
                                            "item-value": "key",
                                            label: value.label,
                                            "hide-no-data": "",
                                            rules: value.rules,
                                            multiple: "",
                                            chips: "",
                                            filled: ""
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                value.display && value.type === "boolean"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            color: "success",
                                            label: value.label
                                          },
                                          model: {
                                            value: value.value,
                                            callback: function($$v) {
                                              _vm.$set(value, "value", $$v)
                                            },
                                            expression: "value.value"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm.dialogModel.showReplaceCheckbox
                ? _c("v-checkbox", {
                    staticStyle: { float: "left" },
                    attrs: { label: "String Replace", "input-value": "true" },
                    on: {
                      change: function($event) {
                        return _vm.fixStringChecked()
                      }
                    },
                    model: {
                      value: _vm.checked,
                      callback: function($$v) {
                        _vm.checked = $$v
                      },
                      expression: "checked"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.dialogModel.hasCancelBtn
                ? _c(
                    "v-btn",
                    {
                      staticClass: "dialog-button dialog-button-secondary",
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dialogModel.cancelText
                            ? _vm.dialogModel.cancelText
                            : "Cancel"
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogModel.hasCloseBtn
                ? _c(
                    "v-btn",
                    {
                      staticClass: "dialog-button dialog-button-secondary",
                      on: { click: _vm.close }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dialogModel.closeText
                            ? _vm.dialogModel.closeText
                            : "Close"
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "dialog-button dialog-button-primary",
                  attrs: { disabled: !_vm.dialogModel.valid },
                  on: { click: _vm.submit }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.dialogModel.okText ? _vm.dialogModel.okText : "Ok"
                    )
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }